// extracted by mini-css-extract-plugin
export default {"wrapper":"QuillEditor_wrapper__0O28x","noMargin":"QuillEditor_noMargin__T2wym","LARGE":"QuillEditor_LARGE__wEAcn","MEDIUM":"QuillEditor_MEDIUM__nljcD"};